import { API } from '@config';
import { HrPersonelServicesAnchorTable } from '@src/types/HrPersonelServicesAnchors';

export const getHrPersonelServicesRequiredPostings = async () => {
  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(`${API}/api/hr-personel-services-required-postings?populate=File&sort=id%3Adesc`, options);
  const data: HrPersonelServicesAnchorTable = await response.json();

  return data;
};
